/* eslint-disable */
export const slugify = string => {
	const a =
		'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
	const b =
		'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
	const p = new RegExp(a.split('').join('|'), 'g');
	return string
		.toString()
		.toLowerCase()
		.replace(/\s+/g, '-')
		.replace(p, c => b.charAt(a.indexOf(c)))
		.replace(/&/g, '-and-')
		.replace(/[^\w\-]+/g, '')
		.replace(/\-\-+/g, '-')
		.replace(/^-+/, '')
		.replace(/-+$/, '');
};
/* eslint-enable */

export const get_player_from_roster_by_slug = (roster, player_slug) => {
	return roster.find(player => player.slug === player_slug);
};

export const sort_by = prop => {
	return (a, b) => (a[prop] < b[prop] ? -1 : a[prop] > b[prop] ? 1 : 0);
};

export const get_players_from_roster_by_count = (count, roster) => {
	return roster.slice(0, count);
};

export const hex2rgba = (hex, alpha = 1) => {
	const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
	return `rgba(${r},${g},${b},${alpha})`;
};

export const value_by_stringed_key = (object, string_key_path) => {
	string_key_path = string_key_path.replace(/\[(\w+)\]/g, '.$1');
	string_key_path = string_key_path.replace(/^\./, '');
	var pieces = string_key_path.split('.');

	for (let i = 0, n = pieces.length; i < n; ++i) {
		var k = pieces[i];
		if (k in object) {
			object = object[k];
		} else {
			return;
		}
	}

	return object;
};

export const create_url_params_from_object = params_obj => {
	let param_string = '';

	Object.keys(params_obj).forEach((key, index) => {
		param_string += index === 0 ? '?' : '&';

		param_string += `${key}=${encodeURIComponent(params_obj[key])}`;
	});

	return param_string;
};

export const generate_components = components => {
	console.log(components);
	return components;
};

export const Lettering = (
	element,
	{
		tagName = 'span',
		split,
		setClassName = function(index) {
			return 'char' + index;
		},
	} = {},
) => {
	element.normalize();
	let index = 1;
	function inject(element) {
		const parentNode = element.parentNode;
		const nodeValue = element.nodeValue;
		const array = split ? split(nodeValue) : nodeValue.split('');
		array.forEach(function(string) {
			const node = document.createElement(tagName);
			const className = setClassName(index++, string);

			if (className) {
				if (string.match(/^ *$/) !== null) {
					const className = setClassName(' space');
					node.className = className;
				} else {
					node.className = className;
				}
			}

			node.appendChild(document.createTextNode(string));
			node.setAttribute('aria-hidden', 'true');
			parentNode.insertBefore(node, element);
		});
		if (nodeValue.trim() !== '') {
			parentNode.setAttribute('aria-label', nodeValue);
		}
		parentNode.removeChild(element);
	}
	(function traverse(element) {
		// `element` is itself a text node
		if (element.nodeType === 3) {
			return inject(element);
		}
		// `element` has a single child text node
		const childNodes = Array.prototype.slice.call(element.childNodes); // static array of nodes
		const length = childNodes.length;
		if (length === 1 && childNodes[0].nodeType === 3) {
			return inject(childNodes[0]);
		}
		// `element` has more than one child node
		childNodes.forEach(function(childNode) {
			traverse(childNode);
		});
	})(element);
};

export const should_use_v2_api = () => {
	return (
		window.isNextGen ||
		(process.env.VUE_APP_V2_API_TENANT != undefined &&
			process.env.VUE_APP_V2_API_BASE_URL != undefined)
	);
};
